module.exports = __webpack_public_path__ + "static/media/city1.ebc5562d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/architect/utils/images/sidebar/city1.jpg
// module id = 512
// module chunks = 0